import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "clipboard"
    }}>{`Clipboard`}</h1>
    <p>{`Read and write content from and to the clipboard.`}</p>
    <h2 {...{
      "id": "system-requirements"
    }}>{`System requirements`}</h2>
    <p>{`Please make sure your local environment uses the following application versions before proceeding.`}</p>
    <ul>
      <li parentName="ul">{`InDesign v18.5 or higher`}</li>
      <li parentName="ul">{`UXP version v7.1 or higher`}</li>
      <li parentName="ul">{`Manifest version v5 or higher`}</li>
    </ul>
    <InlineAlert variant="info" slots="header, text1, text2" mdxType="InlineAlert" />
    <p>{`Plugins and Scripts`}</p>
    <p><strong parentName="p">{`In plugins`}</strong>{`, you should seek permission for `}<inlineCode parentName="p">{`clipboard`}</inlineCode>{` access in the manifest. `}<br></br>{` IMPORTANT: Read about the `}<a parentName="p" {...{
        "href": "../../../plugins/concepts/manifest/#permissionsdefinition"
      }}>{`manifest permissions`}</a>{` before you proceed.`}</p>
    <p><strong parentName="p">{`In scripts`}</strong>{`, the permission for `}<inlineCode parentName="p">{`clipboard`}</inlineCode>{` is fixed. You can ignore the manifest details in the following examples. Learn about these values in the `}<a parentName="p" {...{
        "href": "../../fundamentals/manifest/"
      }}>{`manifest fundamentals section`}</a>{`.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <CodeBlock slots="heading, code" repeat="2" languages="JavaScript, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async function foo() {
    const clipboard = navigator.clipboard;

    // Setting content for clipboard
    clipboard.setContent({ 'text/plain': "Test string to validate clipboard setContent" })
        .then(() => {
            console.log("Data successfully set on clipboard");
        }, (error) => {
            console.error("Error while setting data on clipboard:", error);
        });


    // Reading from clipboard and printing
    clipboard.getContent()
        .then((result) => {
            console.log(\`Data from clipboard: \${result["text/plain"]}\`);
        }, (error) => {
            console.error("Error while reading data from clipboard:", error);
        });
}
`}</code></pre>
    <h4 {...{
      "id": "manifest"
    }}>{`manifest`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "requiredPermissions": {
        "clipboard": "readAndWrite"
    }
}
`}</code></pre>
    <h2 {...{
      "id": "additional-notes"
    }}>{`Additional notes`}</h2>
    <ul>
      <li parentName="ul">{`Set the permission to "read" if your script/plugin only intends to read from the clipboard.`}</li>
    </ul>
    <h2 {...{
      "id": "reference-material"
    }}>{`Reference material`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard/"
        }}>{`Clipboard`}</a>{` APIs`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      